/**
 * Browser-safe HPXML DOM helpers (namespaced XML → localName walks).
 */

export function parseHpxmlDocument(xmlString) {
    if (typeof xmlString !== "string" || !xmlString.trim()) {
        return { doc: null, error: "Empty HPXML string." };
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlString, "application/xml");
    const parseErr = doc.getElementsByTagName("parsererror")[0];
    if (parseErr) {
        return { doc: null, error: parseErr.textContent?.trim() || "Failed to parse XML." };
    }
    return { doc, error: null };
}

export function findFirstDescendantByLocalName(root, localName) {
    if (!root) return null;
    const stack = [...root.children];
    while (stack.length) {
        const el = stack.pop();
        if (el.localName === localName) return el;
        for (let i = el.children.length - 1; i >= 0; i -= 1) {
            stack.push(el.children[i]);
        }
    }
    return null;
}

export function getChildrenByLocalName(el, localName) {
    if (!el?.children) return [];
    return [...el.children].filter((c) => c.localName === localName);
}

export function getChildText(el, localName) {
    const child = getChildrenByLocalName(el, localName)[0];
    return child?.textContent?.trim() ?? "";
}

export function findBuildingDetails(doc) {
    if (!doc?.documentElement) return null;
    return findFirstDescendantByLocalName(doc.documentElement, "BuildingDetails");
}

export function parseNumber(val) {
    if (val == null || val === "") return null;
    const n = Number.parseFloat(String(val));
    return Number.isFinite(n) ? n : null;
}
